export const handleBigNumbers = (value: number, doNotShowDecimals = false) => {
  if (doNotShowDecimals) return Number(value?.toFixed(0)).toLocaleString();
  const formatedValue = Number(value?.toFixed(2)).toLocaleString();
  const cents = formatedValue.split(".")[1];
  if (cents?.length === 2) return formatedValue;
  if (cents?.length === 1) return `${formatedValue}0`;
  return `${formatedValue}.00`;
};
